import React from "react";
import { useState, useEffect } from "react";
import { AgruparByProp } from "../../../../Helpers/Agrupaciones/AgruparByProp";
import { ArrayTotalizarByProp } from "../../Actions/TotalizarProps";
import request from "../../../../Helpers/API";
import { formatFecha } from "./formatFecha";
import { useBoxFiltros, useBox } from "../../Helper/useBox";
import { BoxFiltros2 } from "../../Helper/BoxFiltros2";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { LoaderScreen } from "../../../components/LoaderScreen";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { GetMonthNameByNumber } from "../../Helper/GetMonthNameByNumber";

const fechaActual = new Date();
const ejercicioActual = fechaActual.getFullYear();
const mesActual = fechaActual.getMonth() + 1;

const initialStateboxfiltros = {
  ejercicioinicio: ejercicioActual,
  periodoinicio: "1",
  ejerciciofin: ejercicioActual,
  periodofin: mesActual,
  pv: { adr: [], sucursal: [], departamento: [] },
  visualizacion: "1"
};

export const ResultadosSucursalScreen = () => {
  const [boxstate, setBoxState] = useBox(initialStateboxfiltros);
  const [titulo, setTitulo] = useState('RESULTADOS POR SUCURSAL');
  const history = useHistory();
  const onHome = () => {
    history.push("/Finanzas/Main")
  };
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [state, setState] = useState({
    subtitulo: "",
    data: [],
    conceptos: [],
  });

  useEffect(() => {
    handdleBoxClick();
  }, []);


  const handdleBoxClick = () => {
    return new Promise((res, req) => {
      if (boxstate.ejercicioinicio === "0") {
        req("Favor de agregar el ejercicio de inicio");
        return;
      }
      if (boxstate.periodoinicio === "0") {
        req("Favor de agregar el periodo de inicio");
        return;
      }
      if (boxstate.ejerciciofin === "0") {
        req("Favor de agregar el ejercicio fin");
        return;
      } else if (
        Number(boxstate.ejercicioinicio) > Number(boxstate.ejerciciofin)
      ) {
        req("El ejercicio de inicio debe ser menor o igual al ejercicio final");
        return;
      }
      if (boxstate.periodofin === "0") {
        req("Favor de indicar el periodo final");
        return;
      } else if (
        Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) &&
        Number(boxstate.periodoinicio) > Number(boxstate.periodofin)
      ) {
        req("El periodo de inicio no puede ser mayor a l periodo fin");
        return;
      }

      const fechainicio = new Date(
        boxstate.ejercicioinicio,
        Number(boxstate.periodoinicio) - 1,
        "01"
      );
      const fechafin = new Date(
        boxstate.ejerciciofin,
        Number(boxstate.periodofin) - 1,
        "01"
      );
      const post = {
        fechainicio,
        fechafin,
      };

      setLoader({ ...loader, mostrar: true });

      request
        .post("FEResultadoSucursal/Obtener", post)
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          res("");
          setState({
            ...state,
            data: result,
            subtitulo: `De ${formatFecha(fechainicio)} al ${formatFecha(
              fechafin
            )}`,
            conceptos: AgruparByProp(result, "concepto"),
          });
          if (
            String(boxstate.periodoinicio) === String(boxstate.periodofin) &&
            String(boxstate.ejercicioinicio) === String(boxstate.ejerciciofin)
          ) {
            setTitulo(
              `RESULTADOS POR SUCURSAL ${GetMonthNameByNumber(boxstate.periodoinicio).toUpperCase()} ${boxstate.ejercicioinicio}`
            );
          } else {
            setTitulo(
              `RESULTADOS POR SUCURSAL ${GetMonthNameByNumber(boxstate.periodoinicio).toUpperCase()} ${boxstate.ejercicioinicio} - ${GetMonthNameByNumber(boxstate.periodofin).toUpperCase()} ${boxstate.ejerciciofin}`
            );
          }
        })
        .catch((err) => {
          setLoader({ ...loader, mostrar: false });
          req(JSON.stringify(err));
        });
    });
  };
  const imprimirexcel = () => {

    // if (boxstate.ejercicioinicio === "0") {
    //     changeloading(true,"Favor de agregar el ejercicio de inicio");
    //     return;
    //   }
    //   if (boxstate.periodoinicio === "0") {
    //     changeloading(true,"Favor de agregar el periodo de inicio");
    //     return;
    //   }
    //   if (boxstate.ejerciciofin === "0") {
    //     changeloading(true,"Favor de agregar el ejercicio fin");
    //     return;
    //   } else if (
    //     Number(boxstate.ejercicioinicio) > Number(boxstate.ejerciciofin)
    //   ) {
    //     changeloading(true,"El ejercicio de inicio debe ser menor o igual al ejercicio final");
    //     return;
    //   }
    //   if (boxstate.periodofin === "0") {
    //     changeloading(true,"Favor de indicar el periodo final");
    //     return;
    //   } else if (
    //     Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) &&
    //     Number(boxstate.periodoinicio) > Number(boxstate.periodofin)
    //   ) {
    //     changeloading(true,"El periodo de inicio no puede ser mayor a l periodo fin");
    //     return;
    //   }

    const fechainicio = new Date(
      boxstate.ejercicioinicio,
      Number(boxstate.periodoinicio) - 1,
      "01"
    );
    const fechafin = new Date(
      boxstate.ejerciciofin,
      Number(boxstate.periodofin) - 1,
      "01"
    );
    const post = {
      fechainicio,
      fechafin,
      subtitulo: state.subtitulo.toUpperCase()
    };

    request
      .post("FEResultadoSucursal/GenerarExcel", post)
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((err) => {
        // changeloading(JSON.stringify(err), true);
      });
  };
  return (
    <PlantillaScreen
      titulo={titulo}
      className={"resultados-sucursal-main-screen"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />
      <div className="resultados-sucursal-contenedor-filtros">
        <div className='resultados-sucursal-regresar'
          onClick={() => onHome()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <BoxFiltros2
          boxState={boxstate}
          onBoxChange={setBoxState}
          BoxClick={handdleBoxClick}
          // titulo="RESULTADOS POR SUCURSAL"
          // subtitulo={state.subtitulo.toUpperCase()}
          titulo_filtro={'FILTRO'}
          mostraradr={false}
          mostrardepartamento={false}
          mostrarsucursal={false}
        >
          {/* <h1 key='box-filtro'>Pozolaso</h1> */}
          {/* <div key="box-actions">
          <button className='btn-excel' onClick={imprimirexcel}>Excel</button>
        </div> */}
        </BoxFiltros2>
        <div className="buttons">
          <button className="excel" onClick={() => imprimirexcel()}>
            Excel
          </button>
        </div>
      </div>
      {state.data != undefined &&
        state.data != null &&
        state.data.length === 0 ? (
        <div></div>
      ) : (
        <div className="resultados-sucursal-container">
          <div id="resultados-sucursal" className="scroll">
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr className="col-sticky">
                  <th className="">Concepto</th>
                  <th><div>Navolato</div></th>
                  <th><div>Caimanero</div></th>
                  <th><div>Eldorado</div></th>
                  <th><div>Costa Rica</div></th>
                  <th><div>La Cruz</div></th>
                  <th><div>El Rosario</div></th>
                  <th><div>Villa Union</div></th>
                  <th><div>Tepic</div></th>
                  <th><div>San Jose</div></th>
                  <th><div>Santiago</div></th>
                  <th><div>Tecuala</div></th>
                  <th><div>Las Varas</div></th>
                  <th></th>
                  <th><div>Total</div></th>
                  <th><div>%</div></th>
                  <th><div>Sinaloa</div></th>
                  <th><div>%</div></th>
                  <th><div>Nayarit</div></th>
                  <th><div>%</div></th>
                </tr>
              </thead>
              <tbody>
                {state.conceptos.map((con) => (
                  <>
                    <tr className="encabezado">
                      <td className="row-sticky ">{con}</td>
                      <td>
                        {FormatMoney(
                          (
                            ArrayTotalizarByProp(
                              state.data.filter((x) => x.concepto === con && x.iddepartamento == 0),
                              "navolato"
                            ) === 0
                              ? 0
                              : (ArrayTotalizarByProp(
                                state.data.filter((x) => x.concepto === con && x.iddepartamento == 0),
                                "navolato"
                              ) /
                                ArrayTotalizarByProp(
                                  state.data.filter((x) => x.concepto === con && x.iddepartamento == 0),
                                  "total"
                                )) * 100
                          )
                        )} %

                      </td>
                      <td>
                        {FormatMoney(
                          ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "caimanero") === 0
                            ? 0
                            : (ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "caimanero") /
                              ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "total")) * 100
                        )} %
                      </td>
                      <td>
                        {FormatMoney(
                          ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "eldorado") === 0
                            ? 0
                            : (ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "eldorado") /
                              ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "total")) * 100
                        )} %
                      </td>
                      <td>
                        {FormatMoney(
                          ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "costarica") === 0
                            ? 0
                            : (ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "costarica") /
                              ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "total")) * 100
                        )} %
                      </td>
                      <td>
                        {FormatMoney(
                          ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "lacruz") === 0
                            ? 0
                            : (ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "lacruz") /
                              ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "total")) * 100
                        )} %
                      </td>
                      <td>
                        {FormatMoney(
                          ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "rosario") === 0
                            ? 0
                            : (ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "rosario") /
                              ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "total")) * 100
                        )} %
                      </td>
                      <td>
                        {FormatMoney(
                          ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "villaunion") === 0
                            ? 0
                            : (ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "villaunion") /
                              ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "total")) * 100
                        )} %
                      </td>
                      <td>
                        {FormatMoney(
                          ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "tepic") === 0
                            ? 0
                            : (ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "tepic") /
                              ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "total")) * 100
                        )} %
                      </td>
                      <td>
                        {FormatMoney(
                          ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "sanjose") === 0
                            ? 0
                            : (ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "sanjose") /
                              ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "total")) * 100
                        )} %
                      </td>
                      <td>
                        {FormatMoney(
                          ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "santiago") === 0
                            ? 0
                            : (ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "santiago") /
                              ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "total")) * 100
                        )} %
                      </td>
                      <td>
                        {FormatMoney(
                          ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "tecuala") === 0
                            ? 0
                            : (ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "tecuala") /
                              ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "total")) * 100
                        )} %
                      </td>
                      <td>
                        {FormatMoney(
                          ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "lasvaras") === 0
                            ? 0
                            : (ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "lasvaras") /
                              ArrayTotalizarByProp(state.data.filter(x => x.concepto === con && x.iddepartamento == 0), "total")) * 100
                        )} %
                      </td>
                      <td></td>

                      <td colSpan={6}></td>
                    </tr>
                    {state.data
                      .filter((x) => x.concepto === con)
                      .map((x, index) => (
                        <>
                          <tr
                            className={`
                                                ${x.orden === 3 ||
                                x.orden === 5 ||
                                x.orden === 7 ||
                                x.orden === 9 ||
                                x.orden === 11 ||
                                x.orden === 13 ||
                                x.orden === 15
                                ? "txt-bold"
                                : ""
                              }
                                                        ${x.orden === 14 &&
                                (x.iddepartamento ===
                                  3 ||
                                  x.iddepartamento ===
                                  5)
                                ? "txt-bold fs-12"
                                : ""
                              }
                                                        `}
                          >
                            <td
                              className={`row-sticky  ${index % 2 === 0 ? "" : "br-analisis"
                                }`}
                            >
                              {x.departamento}{" "}
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"
                                }`}
                            >
                              {FormatMoney(x.navolato, 1)}
                              {x.orden === 1 ? " %" : ""}
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"
                                }`}
                            >
                              {FormatMoney(x.caimanero, 1)}
                              {x.orden === 1 ? " %" : ""}
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"
                                }`}
                            >
                              {FormatMoney(x.eldorado, 1)}
                              {x.orden === 1 ? " %" : ""}
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"
                                }`}
                            >
                              {FormatMoney(x.costarica, 1)}
                              {x.orden === 1 ? " %" : ""}
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"
                                }`}
                            >
                              {FormatMoney(x.lacruz, 1)}
                              {x.orden === 1 ? " %" : ""}
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"
                                }`}
                            >
                              {FormatMoney(x.rosario, 1)}
                              {x.orden === 1 ? " %" : ""}
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"
                                }`}
                            >
                              {FormatMoney(x.villaunion, 1)}
                              {x.orden === 1 ? " %" : ""}
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"
                                }`}
                            >
                              {FormatMoney(x.tepic, 1)}
                              {x.orden === 1 ? " %" : ""}
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"
                                }`}
                            >
                              {FormatMoney(x.sanjose, 1)}
                              {x.orden === 1 ? " %" : ""}
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"
                                }`}
                            >
                              {FormatMoney(x.santiago, 1)}
                              {x.orden === 1 ? " %" : ""}
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"
                                }`}
                            >
                              {FormatMoney(x.tecuala, 1)}
                              {x.orden === 1 ? " %" : ""}
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"
                                }`}
                            >
                              {FormatMoney(x.lasvaras, 1)}
                              {x.orden === 1 ? " %" : ""}
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"
                                }`}
                            ></td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"}
                                                ${x.total === 0
                                  ? "txt-none"
                                  : ""
                                }
                                            `}
                            >
                              {FormatMoney(x.total, 1)}
                            </td>
                            <td
                              className={`porcentaje ${index % 2 === 0 ? "" : "br-analisis"
                                }
                                              ${x.total === 0 ? "txt-none" : ""}
                                            `}
                            >
                              {FormatMoney(x.portotal, 1)} %
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"}
                                              ${x.total === 0 ? "txt-none" : ""}
                                            `}
                            >
                              {FormatMoney(x.sinaloa, 1)}
                            </td>
                            <td
                              className={`porcentaje ${index % 2 === 0 ? "" : "br-analisis"
                                }
                                              ${x.total === 0 ? "txt-none" : ""}
                                            `}
                            >
                              {FormatMoney(x.porsinaloa, 1)} %
                            </td>
                            <td
                              className={`${index % 2 === 0 ? "" : "br-analisis"}
                                              ${x.total === 0 ? "txt-none" : ""}
                                            `}
                            >
                              {FormatMoney(x.nayarit, 1)}
                            </td>
                            <td
                              className={`porcentaje ${index % 2 === 0 ? "" : "br-analisis"
                                }
                                              ${x.total === 0 ? "txt-none" : ""}
                                            `}
                            >
                              {FormatMoney(x.pornayarit, 1)} %
                            </td>
                          </tr>
                        </>
                      ))}
                    <tr>
                      <td colSpan={20} className="td-fin"></td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </PlantillaScreen >

  );
};
